import React, { useState, useRef, useEffect, useMemo, useCallback, useContext } from 'react'
import styled from 'styled-components'
import { useAuthState } from 'src/providers/AuthProviders'
import { useNavigate, useParams } from 'react-router-dom'
import { useConversation } from 'src/pages/main/dmTalk/hooks/useConversation'
import { InputDMTalk } from 'src/pages/main/storyTalk/components/InputDMTalk'
import VectorIcon from 'src/assets/img/common/white_backward_rounded_vector.png'
import { ItemChatReceived } from 'src/components/message/ChatBox/MessageReceived'
import { ItemChatRealTalk } from 'src/pages/main/storyTalk/components/ItemChatRealTalk'
import { BtnShowChatBox } from 'src/components/message/BtnShowChatBox'
import TipsModal from 'src/components/common/TipsModal'
import MultiLoveEffectModal from 'src/components/Effect/MultiLoveEffectModal'
import { getConversationItem } from 'src/services/get/getChat'
import NoContent from 'src/components/layouts/NoContent'

import MiniGameIcon from 'src/assets/img/mini_game/btn/btn_game.png'
import { MYPAGE_CHARACTER_IMAGES } from 'src/constants/characters'
import BackGroundDefault from 'src/assets/img/common/bg_common.jpg'
import BgDMTalk from 'src/assets/img/realtalk/bg.svg'
import IconLove from 'src/assets/img/realtalk/heart_white.svg'

import { postBackGround, postIsCheckStory } from 'src/services/post/postBackGround'
import { useLoadingMore } from 'src/services/hooks/useLoadingMore'
import LoadingIcon from 'src/components/layouts/LoadingIcon'
import { MainLayout } from 'src/components/layouts/MainLayout'
import { ModalMiniGame } from 'src/components/common/ModalMiniGame'
import { ModalChangeBg } from 'src/components/common/ModalChangeBg'
import { HistoryRouteContext } from 'src/routes'
import { ModalGift } from 'src/components/common/ModalGift'
import { MAIN_PATHS } from 'src/routes/main'
import { roomType } from 'src/constants/roomTypeList'

export const DmTalkDetail = () => {
  const { characterId } = useParams()
  const navigate = useNavigate()
  const { user } = useAuthState()
  const lastScrollHeight = useRef(0)
  const roomChatRef = useRef()
  const isInitialLoad = useRef(true)

  const {
    data: conversationData,
    isFetching,
    fetchNextPage,
    hasNextPage,
    refetch,
    addNewMessageToCache,
    updateMessageToCache,
    isFetched,
    isFetchingNextPage,
    status
  } = useConversation(roomType.REALTIME)

  const [hidden, setHidden] = useState(false)
  const [sizeInput, setSizeInput] = useState(0)
  const [isOpenGameModal, setIsOpenGameModal] = useState(false)
  const [character, setCharacter] = useState({})
  const [loveLvSettings, setLoveLvSettings] = useState({})
  const [bgImagePreview, setBgImagePreview] = useState('')
  const [isPreview, setIsPreview] = useState(false)
  const [indexBg, setIndexBg] = useState(0)
  const [multiLevel, setMultiLevel] = useState({})
  const [isMultiLoveModalOpen, setIsMultiLoveModalOpen] = useState(false)
  const [isOpenGift, setIsOpenGift] = useState(false)
  const [conversationId, setConversationId] = useState()
  const [present, setPresent] = useState(null)
  const [isClickIconBg, setIsClickIconBg] = useState(false)
  const [files, setFiles] = useState('')
  const [fileVideo, setFileVideo] = useState([])
  const [backgroundSetting, setBackgroundSetting] = useState({})
  const [channelInfo, setChannelInfo] = useState()

  const { redirectTo } = useContext(HistoryRouteContext)

  const isNoContent = useMemo(
    () =>
      isFetched &&
      !conversationData?.pages?.find((page) => page?.first_page)?.character?.allow_realtime_talk,
    [conversationData, isFetched]
  )
  const allMessages = conversationData?.pages?.flatMap((page) => page?.messages || []) || []

  const handleBgCharacter = () => {
    if (conversationData?.pages?.length) {
      switch (conversationData.pages[conversationData.pages.length - 1].background_type) {
        case 0:
          return BgDMTalk
        case 1:
          return BackGroundDefault
        case 2:
          return backgroundSetting
        default:
          return ''
      }
    }
  }

  const backgroundDef = {
    image: '',
    room: BackGroundDefault
  }

  const backgroundPrimary = {
    image: '',
    room: BgDMTalk
  }

  const listBackGround = [backgroundPrimary, backgroundDef, backgroundSetting]

  useEffect(() => {
    conversationData && refetch()
    const updateIsCheckStory = async () => {
      await postIsCheckStory({
        character_id: characterId,
        user_id: user.id,
        is_check_read: true
      })
    }

    updateIsCheckStory()
  }, [])

  useEffect(() => {
    setBackgroundSetting(MYPAGE_CHARACTER_IMAGES[characterId])
  }, [characterId])

  useEffect(() => {
    if (!conversationData) return

    const firstPage = conversationData.pages.find((page) => page.first_page)
    if (firstPage) {
      setCharacter(firstPage.character)
      setConversationId(firstPage.conversation_id)
      setLoveLvSettings(firstPage.character_setting_level)
    }

    if (conversationData.pages && conversationData.pages[0]) {
      setChannelInfo(conversationData.pages[0])
    }
  }, [conversationData])

  useEffect(() => {
    if (roomChatRef.current && status === 'success' && !isFetchingNextPage) {
      const newScrollHeight = roomChatRef.current.scrollHeight

      if (isInitialLoad.current) {
        roomChatRef.current.scrollTop = newScrollHeight
        lastScrollHeight.current = newScrollHeight
        isInitialLoad.current = false
      }
    }
  }, [status, isFetchingNextPage])

  useEffect(() => {
    if (!isFetched || !roomChatRef.current) return

    roomChatRef.current.scrollTop = roomChatRef.current.scrollHeight
  }, [isFetched])

  useLoadingMore({
    selector: '#start',
    skip: !hasNextPage || isFetchingNextPage,
    onLoadMore: async () => {
      await fetchNextPage()
      requestAnimationFrame(() => {
        if (roomChatRef.current) {
          const newScrollHeight = roomChatRef.current.scrollHeight
          if (lastScrollHeight.current > 0) {
            roomChatRef.current.scrollTop = newScrollHeight - lastScrollHeight.current
          }
          lastScrollHeight.current = newScrollHeight
        }
      })
    },
    root: roomChatRef.current
  })

  const handleClose = useCallback(() => {
    setIsOpenGameModal(false)
  }, [isOpenGameModal])

  const closeMultiLoveModal = useCallback(() => {
    setIsMultiLoveModalOpen(false)
    refetch()
  }, [setIsMultiLoveModalOpen])

  const handleOpenGift = async (type, msg) => {
    const giftId = type === 'character_cloth' ? msg.character_cloth_id : msg.setting_item_id
    const giftAmount = type === 'character_cloth' ? msg.number_of_avatar : msg.setting_item_amount
    if (
      (type === 'character_cloth' && !msg.is_received_cloth) ||
      (type === 'setting_item' && !msg.is_received_present)
    ) {
      const res = await getConversationItem(msg.character_chat_id, type, giftId, giftAmount)

      if (res) {
        if (!res.items) return
        setPresent(res.items)
        setIsOpenGift(true)
        if (type === 'character_cloth') {
          msg.is_received_cloth = true
        } else if (type === 'setting_item') {
          msg.is_received_present = true
        }
        updateMessageToCache(msg)
      } else {
        console.log('プレゼントは受け取り済みです')
      }
    }
  }

  const handleSetBgCharacter = () => {
    setIsPreview(false)
    postBackGround({
      background_type: indexBg,
      character_id: characterId,
      user_id: user.id
    })
  }

  return (
    <MainLayout showFooter={false} classNameHeader="">
      {isNoContent ? (
        <div className="h-full flex items-center">
          <NoContent
            isModal
            message={'直前のページに戻ります。\nナビゲーターにお知らせください'}
            redirectUrl={MAIN_PATHS.RealtimePage}
          />
        </div>
      ) : (
        <>
          <ModalChangeBg
            isOpen={isClickIconBg}
            onClose={() => setIsClickIconBg(false)}
            listBackGround={listBackGround}
            onChangeBg={(url, index) => {
              setIndexBg(index)
              setIsClickIconBg(false)
              setIsPreview(true)
              setBgImagePreview(url)
            }}
          />
          <div className="h-[83px] md:w-[400px] w-full bg-[#6F9BFF66]/40 flex items-end justify-between px-[16px] z-[11] pb-2">
            <div className="flex items-center justify-between gap-2">
              <button>
                <img
                  className="w-[8px] h-[17px]"
                  src={VectorIcon}
                  alt=""
                  onClick={() => redirectTo(MAIN_PATHS.RealtimePage)}
                />
              </button>
              <span className="text-[18px] text-white">{character?.name}</span>
            </div>
            <div className="flex flex-col">
              <span className="text-[7px] text-[#FFFFFF] font-bold">LOVE度</span>
              <div
                className="flex h-[18px] items-center justify-center"
                style={{ backgroundImage: `url(${IconLove})`, backgroundRepeat: 'no-repeat' }}
              >
                <span className="font-Inter leading-[0px] text-[#A8C3FF] text-xs font-bold">
                  {character?.level?.love?.level}
                </span>
              </div>
            </div>
          </div>
          <div
            className={`${
              hidden ? 'hidden' : 'block'
            } bg-no-repeat bg-cover h-[calc(100dvh-167px)] relative`}
            style={{ backgroundImage: `url(${bgImagePreview || handleBgCharacter()})` }}
          >
            <div className={'rounded-[14px]'}>
              <WrapperChatBox sizeInput={sizeInput} ref={roomChatRef}>
                {conversationData && (
                  <img
                    src={MiniGameIcon}
                    alt="ミニゲームアイコン"
                    className="absolute top-2 right-3 w-[12%] aspect-square cursor-pointer z-20"
                    onClick={() => setIsOpenGameModal(true)}
                  />
                )}
                {isFetching ? <LoadingIcon /> : <div id="start" />}
                {allMessages.map((message, i) => (
                  <div key={i}>
                    {message?.is_owner ? (
                      <ItemChatReceived data={message} />
                    ) : (
                      <ItemChatRealTalk
                        msg={message}
                        loveLvSettings={loveLvSettings}
                        character={character}
                        isScrollOpenTalk={() => {}}
                        setMultiLevel={setMultiLevel}
                        setIsMultiLoveModalOpen={setIsMultiLoveModalOpen}
                        handleOpenGift={handleOpenGift}
                      />
                    )}
                    <br />
                  </div>
                ))}
                <br />
              </WrapperChatBox>
            </div>
            <div className="fixed bottom-0 mx-auto z-20 w-screen sm:w-desktop-width">
              {isPreview ? (
                <div className="flex justify-around items-center h-[87px]">
                  <button
                    className={
                      'w-[40%] text-white text-[24px] font-bold text-center rounded-[32px] py-2 font-MPlus1 bg-metallic-gray'
                    }
                    onClick={() => {
                      setIsPreview(false)
                      setBgImagePreview(handleBgCharacter())
                    }}
                  >
                    キャンセル
                  </button>
                  <button
                    className={
                      'w-[40%] text-white text-[24px] font-bold text-center rounded-[32px] py-2 font-MPlus1 bg-cornflower-blue'
                    }
                    onClick={() => {
                      handleSetBgCharacter()
                    }}
                  >
                    変更する
                  </button>
                </div>
              ) : (
                <InputDMTalk
                  setIsClickIconBg={setIsClickIconBg}
                  senderId={user?.id}
                  conversationId={conversationId}
                  handleNewMessages={(msg) => {
                    if (msg) {
                      addNewMessageToCache(msg)
                      setTimeout(() => {
                        roomChatRef.current?.scrollTo({
                          top: roomChatRef.current.scrollHeight
                        })
                      }, 100)
                    }
                    setFiles(null)
                  }}
                  setSizeInput={setSizeInput}
                  characterId={Number(characterId)}
                  loveLvSettings={loveLvSettings}
                  character={character}
                  setFiles={setFiles}
                  files={files}
                  setFileVideo={setFileVideo}
                  fileVideo={fileVideo}
                  setIsMultiLoveModalOpen={setIsMultiLoveModalOpen}
                  setMultiLevel={setMultiLevel}
                  channelInfo={channelInfo}
                />
              )}
            </div>
          </div>
          <div className="absolute bottom-[11px] right-[16px]" onClick={() => setHidden(false)}>
            {hidden ? <BtnShowChatBox /> : null}
          </div>
          <ModalMiniGame
            isOpen={isOpenGameModal}
            onClose={handleClose}
            onPlay={() => navigate(MAIN_PATHS.MiniGame, { state: { characterId } })}
          />
          <MultiLoveEffectModal
            character={character}
            isMultiLoveModalOpen={isMultiLoveModalOpen}
            multiLevel={multiLevel}
            onClose={closeMultiLoveModal}
          />
          <ModalGift isOpen={isOpenGift} onClose={() => setIsOpenGift(false)} present={present} />
          <TipsModal type="message_detail" isDetail={true} />
        </>
      )}
    </MainLayout>
  )
}

const WrapperChatBox = styled.div.attrs({
  className: 'overflow-y-auto overflow-x-hidden hidden-scroll'
})`
  height: calc(100dvh - 167px);
  padding: 2px 4px 0 4px;
`
